export default __webpack_public_path__ + "static/media/selectUnselectedBlack.d1fdd11a.svg";